export default {
    getDashboardStatisticsBasic(state) {
        
        return state.dashboardStatisticsBasic;
    },
};
